define(function(require) {
    return {
        LAYERS : [
            {LAYER_ID: "GEO07E12_POINTS_SPES", DATACOLUMNS: [{ID: "NBR_ELEVES", DATATABLE_ID: "t_GEO07E12_POINTS_SPES"}]},
            {LAYER_ID: "GEO07E16_POINTS_0_AN_SPES", DATACOLUMNS: [{ID: "POP_0", DATATABLE_ID: "t_GEO07E16_POINTS_0_AN_SPES"}]},
            {LAYER_ID: "GEO07E16_POINTS_1_AN_SPES", DATACOLUMNS: [{ID: "POP_1", DATATABLE_ID: "t_GEO07E16_POINTS_1_AN_SPES"}]},
            {LAYER_ID: "GEO07E16_POINTS_2_ANS_SPES", DATACOLUMNS: [{ID: "POP_2", DATATABLE_ID: "t_GEO07E16_POINTS_2_ANS_SPES"}]},
            {LAYER_ID: "GEO07E16_POINTS_3_ANS_SPES", DATACOLUMNS: [{ID: "POP_3", DATATABLE_ID: "t_GEO07E16_POINTS_3_ANS_SPES"}]},
            {LAYER_ID: "GEO07E16_POINTS_4_ANS_SPES", DATACOLUMNS: [{ID: "POP_4", DATATABLE_ID: "t_GEO07E16_POINTS_4_ANS_SPES"}]},
            {
                LAYER_ID: "GEO07E16_POINTS_0_4_ANS_SPES",
                DATACOLUMNS: [
                    {ID: "POP_0", DATATABLE_ID: "t_GEO07E16_POINTS_0_4_ANS_SPES"},
                    {ID: "POP_1", DATATABLE_ID: "t_GEO07E16_POINTS_0_4_ANS_SPES"},
                    {ID: "POP_2", DATATABLE_ID: "t_GEO07E16_POINTS_0_4_ANS_SPES"},
                    {ID: "POP_3", DATATABLE_ID: "t_GEO07E16_POINTS_0_4_ANS_SPES"},
                    {ID: "POP_4", DATATABLE_ID: "t_GEO07E16_POINTS_0_4_ANS_SPES"},
                    {ID: "POP_0_4", DATATABLE_ID: "t_GEO07E16_POINTS_0_4_ANS_SPES"},
                ]
            }
        ],
        STATS: [
            { TITLE: "Moyenne:", ID: "AVERAGE" },
            { TITLE: "Écart type:", ID: "STANDARD_DEVIATION" },
            { TITLE: "Médiane:", ID: "MEDIAN" },
            { TITLE: "Maximum:", ID: "MAX" },
            { TITLE: "Minimum:", ID: "MIN" },
        ]
    };
});
